var _path, _path2, _path3, _g, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_95_9013)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_95_9013",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9268 0.136719H2.14133C1.14856 0.136719 0.34375 0.941524 0.34375 1.9343V9.12463C0.34375 10.1174 1.14856 10.9222 2.14133 10.9222H12.9268C13.9196 10.9222 14.7244 10.1174 14.7244 9.12463V1.9343C14.7244 0.941524 13.9196 0.136719 12.9268 0.136719Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_95_9013)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5247 0.289062H1.54078C0.961659 0.289062 0.492188 0.758534 0.492188 1.33766V9.7264C0.492188 10.3055 0.961659 10.775 1.54078 10.775H13.5247C14.1038 10.775 14.5733 10.3055 14.5733 9.7264V1.33766C14.5733 0.758534 14.1038 0.289062 13.5247 0.289062Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.299597
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_95_9013",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5227 0.292969H1.53883C0.959705 0.292969 0.490234 0.76244 0.490234 1.34156V9.73031C0.490234 10.3094 0.959705 10.7789 1.53883 10.7789H13.5227C14.1019 10.7789 14.5713 10.3094 14.5713 9.73031V1.34156C14.5713 0.76244 14.1019 0.292969 13.5227 0.292969Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.299597
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_95_9013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.341797 3.73579H14.7225V0.140625H0.341797V3.73579Z",
    fill: "#FFA44A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.341797 10.9272H14.7224V7.33203H0.341797V10.9272Z",
    fill: "#1A9F0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53161 6.81047C8.2183 6.81047 8.75853 6.22887 8.75853 5.53219C8.75853 4.83551 8.2183 4.25391 7.53161 4.25391C6.84493 4.25391 6.30469 4.83551 6.30469 5.53219C6.30469 6.22887 6.84493 6.81047 7.53161 6.81047Z",
    fill: "#181A93",
    fillOpacity: 0.15,
    stroke: "#181A93",
    strokeWidth: 0.399463
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53185 5.89481C7.72095 5.89481 7.87425 5.73385 7.87425 5.5353C7.87425 5.33674 7.72095 5.17578 7.53185 5.17578C7.34275 5.17578 7.18945 5.33674 7.18945 5.5353C7.18945 5.73385 7.34275 5.89481 7.53185 5.89481Z",
    fill: "#181A93"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9248 0.320312H2.13931C1.24581 0.320312 0.521484 1.04464 0.521484 1.93814V9.12847C0.521484 10.022 1.24581 10.7463 2.13931 10.7463H12.9248C13.8183 10.7463 14.5426 10.022 14.5426 9.12847V1.93814C14.5426 1.04464 13.8183 0.320312 12.9248 0.320312Z",
    stroke: "#C4CAD4",
    strokeWidth: 0.359517
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_95_9013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3807,
    height: 10.7855,
    fill: "white",
    transform: "translate(0.341797 0.140625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountry);
export default __webpack_public_path__ + "static/media/country.711d2a01a84fa9a1ce429610bf552c0d.svg";
export { ForwardRef as ReactComponent };